<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="/">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>服务项目列表</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 搜索 -->
    <div class="content">
      <el-form
        inline
        label-position="right"
        label-width="60px"
        size="small"
        class="query-form"
        @submit.native.prevent="getList();"
      >
        <el-form-item label="搜索">
          <el-input v-model="query.key" placeholder="请输入关键词"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="selClick();">查询</el-button>
          <el-button type="success" @click="dialogVisible=true;form={isEnable:true};">新增</el-button>
        </el-form-item>
      </el-form>

      <!-- 主体 -->
      <el-card class="box-card table">
        <div class="clearfix" slot="header">
          <span>服务项目列表</span>
        </div>

        <!-- <el-tabs v-model="query.cateID" @tab-click="tabClick">
          <el-tab-pane
            v-for="item in catelist"
            :label="item.name"
            :name="item.id.toString()"
            :key="item.id"
          ></el-tab-pane>
        </el-tabs>-->

        <!-- 列表 -->
        <el-table
          v-loading="loading"
          :data="tableData"
          ref="tableData"
          border
          stripe
          style="width:100%"
          @sort-change="sortChange"
          @filter-change="filterTag"
        >
          <el-table-column label="服务名称">
            <template slot-scope="scope">
              <a :href="scope.row.url" target="_blank">{{scope.row.title}}</a>
            </template>
          </el-table-column>
          <el-table-column prop="applyCount" label="申请人数"></el-table-column>
          <el-table-column prop="viewCount" label="浏览次数"></el-table-column>
          <el-table-column prop="sort" label="排序"></el-table-column>
          <el-table-column prop="createTime" label="添加时间"></el-table-column>

          <!-- 操作 -->
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button-group>
                <el-tooltip content="编辑" placement="top">
                  <el-button
                    type="primary"
                    size="small"
                    icon="el-icon-edit"
                    @click="editClick(scope.row)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip content="删除" placement="top">
                  <el-button
                    type="warning"
                    size="small"
                    icon="el-icon-delete"
                    @click="delClick(scope.row)"
                  ></el-button>
                </el-tooltip>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="block" style="margin-top:20px;">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage4"
            :page-size="pageSize"
            :page-sizes="[10,20,30,50,100]"
            layout="total,sizes,prev,pager,next,jumper"
            :total="total"
          ></el-pagination>
        </div>
      </el-card>
    </div>

    <!-- 弹框 -->
    <el-dialog
      :title="form.id>0?'编辑服务项目':'添加服务项目'"
      :visible.sync="dialogVisible"
      @opened="dialogOpened()"
    >
      <el-form
        :model="form"
        ref="form"
        label-width="100px"
        :status-icon="true"
        @submit.native.prevent="submitForm(form)"
      >
        <el-form-item prop="title" label="服务名称" :rules="[{required:true,message:'不能为空'}]">
          <el-input v-model="form.title" placeholder="请输入服务名称"></el-input>
        </el-form-item>

        <el-form-item label="代表图" :rules="[{required:true,message:'不能为空'}]">
          <div id="uploadBtn8" class="uploader uploader-warning" style="position:absolute;top:5px;"></div>
          <img
            :src="domain+form.imgUrl"
            style="width:50px;position:relative;left:100px;top:5px;"
            alt
            v-if="form.imgUrl"
          />
          <span class="uploadslot">*图片尺寸：330*220</span>
        </el-form-item>

        <el-row :gitter="20">
          <!-- <el-col :span="12">
            <el-form-item prop="cateID" label="所属模块" :rules="[{required:true,message:'不能为空'}]">
              <el-select v-model="form.cateID" clearable placeholder="请选择所属模块">
                <el-option
                  v-for="item in catelist"
                  :label="item.name"
                  :key="item.id"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>-->
          <el-col :span="12">
            <el-form-item prop="applyCount" label="申请人数" :rules="[{required:true,message:'不能为空'}]">
              <el-input type="number" v-model.number="form.applyCount" placeholder="请输入申请人数"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="sort" label="排序">
              <el-input type="number" v-model.number="form.sort" placeholder="请输入排序号"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item prop="content" label="内容:" :rules="[{required:true,message:'不能为空'}]">
          <div style="position:relative;">
            <vue-ueditor-wrap v-model="form.content" :config="editorConfig"></vue-ueditor-wrap>
          </div>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" :loading="submiting" native-type="submit">提交</el-button>
          <el-button @click="dialogVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import VueUeditorWrap from "vue-ueditor-wrap"; // ES6 Module
import url from "@/plugins/urlHelper.js";
import json from "@/plugins/jsonHelper.js";
export default {
  data() {
    return {
      domain: url.getDomain(),
      query: {
        cateID: "1"
      },
      form: {},
      dialogVisible: false,
      loading: false,
      submiting: false,
      tableData: [],
      total: 0,
      pageSize: 10,
      currentPage4: 1,
      content: "",
      editorConfig: {
        zIndex: 3000, //配置控件组件弹出层
        initialFrameHeight: 300, //设置高度
        initialFrameWidth: "100%", //设置宽度
        UEDITOR_HOME_URL: url.getUEConfig(),
        serverUrl: url.getUE()
      },
      catelist: []
    };
  },
  methods: {
    handleSizeChange: function(val) {
      this.pageSize = val;
      this.currentPage4 = 1;
      this.getList();
    },
    handleCurrentChange: function(val) {
      this.currentPage4 = val;
      this.getList();
    },
    //   排序
    sortChange: function(sortColumn) {
      this.query.sort = sortColumn.sort;
      this.query.order = sortColumn.order;
      this.getList();
    },
    // 筛选
    filterTag: function(filter) {
      var val = filter["isEnable"][0];
      this.form.isEnable = val;
      this.getList();
    },
    // 切换
    tabClick: function() {
      (this.tableData = []), this.getList();
    },
    //   列表
    getList: function() {
      var _this = this;
      _this.loading = true;
      var params = _this.query;
      params.pageSize = _this.pageSize;
      params.pageIndex = _this.currentPage4;
      var link = url.getSch("getlist_service");
      $.get(link, params, data => {
        _this.loading = false;
        _this.tableData = data.list;
        _this.total = data.total;
      });
    },
    // 所属模块
    getTypeList: function() {
      var _this = this;
      // _this.catelist = json.getTypeList();
    },
    // 查询
    selClick: function() {
      this.currentPage4 = 1;
      this.getList();
    },
    // 编辑
    editClick: function(row) {
      var _this = this;
      _this.dialogVisible = true;
      var id = row.id;
      var link = url.getSch("getmodel_service");
      $.get(link, { id: id }, data => {
        _this.form = data;
      });
    },
    // 删除
    delClick: function(row) {
      var _this = this;
      var id = row.id;
      var link = url.getSch("delete_service");

      this.$confirm("确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          $.post(link, { id: id }, res => {
            if (res.status) {
              _this.dialogVisible = false;
              _this.getList();
              _this.$message({
                type: "success",
                message: res.msg
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 上传
    dialogOpened: function() {
      var _this = this;
      if ($("#uploadBtn8 input").length == 0) {
        $("#uploadBtn8").uploader({
          url: url.getUpload(),
          fileExts: "jpg;png",
          type: "dialog",
          text: "上传图片",
          maxSize: 1024 * 1024 * 1, //上传图片最大值
          subfolder: "content", //默认后台处理简单模式 ，指定子文件夹
          more: false, //是否可以上传多个
          auto: true, //是否自动上传
          coverParams: {
            title: "上传图片",
            targetWidth: 330,
            targetHeight: 220
          },
          onSuccess: function(data) {
            var src = url.getDomain() + data.relativeName;
            _this.$set(_this.form, "imgUrl", data.relativeName);
          }
        });
      }
    },
    // 提交
    submitForm: function(formName) {
      var _this = this;
      var link = url.getSch("save_service");
      var info = _this.form;
      //验证提醒
      if (!info.imgUrl) {
        _this.$message({
          type: "error",
          message: "请上传代表图"
        });
        return;
      }
      info.cateID=2;//默认研究生
      this.$refs.form.validate(valid => {
        if (valid) {
          _this.submiting = true;

          // 提交后台   添加或修改
          $.post(link, info, res => {
            _this.submiting = false;
            if (res.status) {
              _this.dialogVisible = false;
              _this.getList();
              _this.$message({
                type: "success",
                message: res.msg
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg
              });
            }
          });
        } else {
          return false;
        }
      });
    }
  },
  components: {
    VueUeditorWrap
  },
  mounted() {
    //   列表
    this.getList();
    // 所属模块
    this.getTypeList();
  }
};
</script>